import React from 'react';
import samoyedLogo from '../img/Samoyed1.png'; // Import the Samoyed logo image
import '../App.css';

function Header() {
  return (
    <header id="header">
      <div className='header-content'>
        <h3 className='hey-there'>Hey there!</h3>
        <h1>I'm Antía Julia Alamán Martínez</h1>
        <h3 className='developer'>Software Developer</h3>
      </div>
      <img src={samoyedLogo} alt="Samoyed Logo" className="samoyed-logo" /> {/* Add the Samoyed logo */}
    </header>
  );
}

export default Header;
